import angular from 'angular';
import uiRouter from 'angular-ui-router';
import analyticsComponent from './analytics-revenue.component';

let analyticsModule = angular.module('app.containers.analytics-revenue', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('analyticsRevenue', {
      url: '/analytics-revenue',
      template: '<analytics-revenue></analytics-revenue>'
    });
})

.component('analyticsRevenue', analyticsComponent);

export default analyticsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-revenue/analytics-revenue.js
 **/